import { useTranslation } from 'react-i18next';
import type { FormCheckboxType } from '#pie/components/form/types';
import {
  ConsumptionType,
  type CreateDataRequestDto,
  EnergyType,
} from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormCheckbox } =
  typedFormFields<CreateDataRequestDto>();

export const EnergyTypesConsumption = () => {
  // Verbruiksdata energiesoort
  const { t } = useTranslation('dataRequest');
  const options: FormCheckboxType[] = [
    {
      label: t(`energy_type_consumption.${EnergyType.Electricity}`),
      value: EnergyType.Electricity,
    },
    {
      label: t(`energy_type_consumption.${EnergyType.Gas}`),
      value: EnergyType.Gas,
    },
  ];

  return (
    <ConditionalField
      field="energyTypesConsumption"
      condition={(formValue) => {
        return (
          (!!formValue('consumptionTypes')?.length &&
            !formValue('consumptionTypes')!.includes(ConsumptionType.Other)) ||
          (!!formValue('consumptionTypeNote') &&
            formValue('consumptionTypeNote')!.length > 2)
        );
      }}
    >
      <FormCheckbox
        label={t('energy_types_consumption')}
        name="energyTypesConsumption"
        options={options}
        rules={{ required: true }}
      />
    </ConditionalField>
  );
};
